import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEdit,
  FaFileImport,
  FaPlus,
  FaSave,
} from "react-icons/fa"
import { MdCancel, MdDelete } from "react-icons/md"
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { usePermissionData } from "AppContext"

const StoreIndex = () => {
  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)
  // State
  const [store, setstore] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editingDept, setEditingDept] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  useEffect(() => {
    getstore()
  }, [])

  async function getstore() {
    const APIdata = await fetchData(setLoading, "store")
    if (APIdata?.success) {
      setstore(APIdata?.data)
    }
  }

  // Toggle modal
  const toggleModal = () => setModalOpen(!modalOpen)

  // Open modal for Edit
  const handleEdit = dept => {
    setEditingDept(dept)
    toggleModal()
  }

  // Save store
  const handleSave = async () => {
    if (!editingDept?.storeName?.trim()) {
      Swal.fire({ title: "Store name is required", icon: "warning" })
      return
    }
    if (editingDept?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "store",
        editingDept?.id,
        editingDept
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Store Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getstore()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Updating store",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "store", editingDept)
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Store Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getstore()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding store",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to Delete this ${item?.storeName} Store`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }
    const APIdata = await FetchDeleteData(setLoading, "store", item?.id)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Store Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        getstore()
      }, 1500)
    } else {
      Swal.fire({
        title: "Error deleting Store",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  // Filtered & paginated store
  const filteredDepts = useMemo(
    () =>
      store.filter(d =>
        d?.storeName?.toLowerCase().includes(searchText.toLowerCase())
      ),
    [store, searchText]
  )

  const totalPages = Math.ceil(filteredDepts.length / perPage)
  const paginatedDepts = filteredDepts.slice(
    (page - 1) * perPage,
    page * perPage
  )

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="Store" />
      <Card>
        <CardBody>
          {/* ===== FILTER BAR ===== */}
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-3">
              <select
                className="form-select"
                style={{ width: "100px" }}
                value={perPage}
                onChange={e => {
                  setPerPage(Number(e.target.value))
                  setPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>

              <Input
                placeholder="Search..."
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value)
                  setPage(1)
                }}
              />
            </div>

            {checkAccess(13, "add") && (
              <Button
                className="btn-blue"
                onClick={() => {
                  toggleModal(), setEditingDept({})
                }}
              >
                <FaPlus className="me-1" />
                Add
              </Button>
            )}
          </div>

          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Store Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedDepts.length > 0 ? (
                paginatedDepts.map((dept, index) => (
                  <tr key={dept.id}>
                    <td>{(page - 1) * perPage + index + 1}</td>
                    <td>{dept.storeName}</td>
                    <td>
                      {checkAccess(13, "edit") && (
                        <Button
                          color="warning"
                          className="me-2"
                          onClick={() => handleEdit(dept)}
                        >
                          <FaEdit />
                        </Button>
                      )}
                      {dept?.id !== 1 && checkAccess(13, "delete") && (
                        <Button
                          color="danger"
                          onClick={() => handleDelete(dept)}
                        >
                          <MdDelete />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No Store found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* ===== PAGINATION ===== */}
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {page} of {totalPages || 1}
            </span>
            {/* ===== PAGINATION ===== */}
            <div className="d-flex justify-content-center align-items-center gap-2 ">
              {/* Previous */}
              <Button
                disabled={page === 1}
                onClick={() => setPage(prev => prev - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>

              {/* Page Numbers (Show 5 at a time) */}
              {(() => {
                const pageNumbers = []
                const maxVisiblePages = 5

                let startPage = Math.max(
                  1,
                  page - Math.floor(maxVisiblePages / 2)
                )

                let endPage = startPage + maxVisiblePages - 1

                if (endPage > totalPages) {
                  endPage = totalPages
                  startPage = Math.max(1, endPage - maxVisiblePages + 1)
                }

                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(
                    <Button
                      key={i}
                      color={page === i ? "primary" : "light"}
                      onClick={() => setPage(i)}
                    >
                      {i}
                    </Button>
                  )
                }

                return pageNumbers
              })()}

              {/* Next */}
              <Button
                disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(prev => prev + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Add/Edit Modal */}
      <Modal isOpen={modalOpen} centered>
        <ModalHeader toggle={toggleModal}>
          {editingDept?.id ? "Edit Store" : "Add Store"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <Label>Store Name</Label>
            <Input
              type="text"
              value={editingDept?.storeName || ""}
              onChange={e =>
                setEditingDept(prev => ({
                  ...prev,
                  storeName: e.target.value.replace(/^\s+/, ""),
                }))
              }
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            <FaSave /> Save
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            <MdCancel /> Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default StoreIndex
